import Api from "./axios";

export const getBanner = async () => {
    return await Api.get(`/v1/banner`)
}

export const uploadBannerApi  = async (data) => {
    return await Api.post(`/v1/banner`,data)
}